var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "testimonial-quote" }, [
    _c("blockquote", { staticClass: "testimonial-quote__quote" }, [
      _c("span", { staticClass: "testimonial-quote__large-quote" }, [
        _vm._v("“")
      ]),
      _vm._v(_vm._s(_vm.quote.quote) + " ”")
    ]),
    _c("div", { staticClass: "testimonial-quote__text" }, [
      _c("p", { staticClass: "testimonial-quote__name" }, [
        _vm._v(_vm._s("-" + _vm.quote.name + ", " + _vm.quote.city))
      ]),
      _vm.quote.ctaUrl
        ? _c("div", { staticClass: "testimonial-quote__cta" }, [
            _c(
              "a",
              {
                staticClass: "testimonial-quote__button",
                attrs: { href: _vm.quote.ctaUrl }
              },
              [_vm._v(_vm._s(_vm.quote.ctaText))]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }